module.exports = __webpack_public_path__ + "img/80.f4560862.svg";